import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import client from "../assets/images/client/16.jpg";

import {
  FiAirplay,
  FiBell,
  FiCreditCard,
  FiFileText,
  FiLogOut,
  FiMapPin,
  FiSettings,
  FiShare2
} from "../assets/icons/vander";

export default function Usertab() {
  const [file, setFile] = useState(client);
  const [customerDetails, setCustomerDetails] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  let current = window.location.pathname;
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

  const customerId = localStorage.getItem("customer_id");

  const fetchProfile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/profile/?customer_id=${customerId}`
      );
      setCustomerDetails(response.data.customer_details);

      // Set profile picture if available
      if (response.data.customer_details.profile_picture) {
        setFile(
          BASE_MEDIA_URL + response.data.customer_details.profile_picture
        );
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const customer_name = customerDetails.first_name && customerDetails.last_name
    ? customerDetails.first_name + " " + customerDetails.last_name
    : " Jesus Zamora";

  const handleChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Create preview
    const objectUrl = URL.createObjectURL(selectedFile);
    setFile(objectUrl);

    // Upload to server
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("profile_picture", selectedFile);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/profile/?customer_id=${customerId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Update local state with new profile picture
      setCustomerDetails((prev) => ({
        ...prev,
        profile_picture: objectUrl,
      }));

      toast.success("Profile picture updated successfully!", {
        position: "top-center",
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      toast.error("Failed to update profile picture. Please try again.", {
        position: "top-center",
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
      });
      // Revert to previous image on error
      if (customerDetails.profile_picture) {
        setFile(BASE_MEDIA_URL + customerDetails.profile_picture);
      } else {
        setFile(client);
      }
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="lg:w-1/4 md:w-1/3 md:px-3">
      <div className="relative md:-mt-48 -mt-32">
        <div className="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <div className="profile-pic text-center mb-5">
            <input
              id="pro-img"
              name="profile-image"
              type="file"
              className="hidden"
              onChange={handleChange}
              accept="image/*"
              disabled={isUploading}
            />
            <div>
              <div className="relative h-28 w-28 mx-auto">
                <img
                  src={file}
                  className="rounded-full h-28 w-28 shadow dark:shadow-gray-800 ring-4 ring-slate-50 dark:ring-slate-800"
                  id="profile-image"
                  alt=""
                />
                {isUploading && (
                  <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                    <div className="text-white text-sm">Uploading...</div>
                  </div>
                )}
                <label
                  className={`absolute inset-0 cursor-pointer ${
                    isUploading ? "pointer-events-none" : ""
                  }`}
                  htmlFor="pro-img"
                ></label>
              </div>

              <div className="mt-4">
                <h5 className="text-lg font-semibold">
                  {customer_name ? customer_name : "Jesus Zamora"}
                </h5>
                <p className="text-slate-400">
                  {customerDetails.email
                    ? customerDetails.email
                    : "jesus@hotmail.com"}
                </p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-100 dark:border-gray-700">
            <ul className="list-none sidebar-nav mb-0 pb-0" id="navmenu-nav">
              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-account" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-account"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiAirplay className="size-4"></FiAirplay>
                  </span>
                  <h6 className="mb-0 font-medium">My Order</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-billing" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-billing"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiMapPin className="size-4"></FiMapPin>
                  </span>
                  <h6 className="mb-0 font-medium">shipping address</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-payment" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-payment"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiCreditCard className="size-4"></FiCreditCard>
                  </span>
                  <h6 className="mb-0 font-medium">Payment</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-invoice" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-invoice"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiFileText className="size-4"></FiFileText>
                  </span>
                  <h6 className="mb-0 font-medium">Invoice</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-social" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-social"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiShare2 className="size-4"></FiShare2>
                  </span>
                  <h6 className="mb-0 font-medium">Social Profile</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-notification" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-notification"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiBell className="size-4"></FiBell>
                  </span>
                  <h6 className="mb-0 font-medium">Notifications</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/user-setting" ? "active" : ""
                }`}
              >
                <Link
                  to="/user-setting"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiSettings className="size-4"></FiSettings>
                  </span>
                  <h6 className="mb-0 font-medium">Settings</h6>
                </Link>
              </li>

              <li
                className={`navbar-item account-menu ms-0 ${
                  current === "/lock-screen" ? "active" : ""
                }`}
              >
                <Link
                  to="/lock-screen"
                  className="navbar-link text-slate-400 flex items-center py-2 rounded"
                >
                  <span className="me-2 mb-0">
                    <FiLogOut className="size-4"></FiLogOut>
                  </span>
                  <h6 className="mb-0 font-medium">Sign Out</h6>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
